import { register } from "async-ops";
import { callMvcApi } from "../../../../../call-web-api";
export const GET_CASE_VOLUME_LIST = "GET_CASE_VOLUME_LIST";

export const service = async (data) => {
  const options: object = {
    url: `/Api/Analytics/GetCaseCount`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_CASE_VOLUME_LIST, service, mock);
